//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { getConnectedInstagramBusinessAccountId } from '@instagram-account/redux/selectors/getConnectedInstagramBusinessAccountId';
import NetworkUserId from '@models/NetworkUserId';

export const getConnectedInstagramBusinessAccountIdAsNetworkUserId =
  createSelector(getConnectedInstagramBusinessAccountId, (instagramId) =>
    instagramId ? NetworkUserId(instagramId as string) : undefined,
  );
